import { combineReducers } from 'redux'

import profile from './college/profile'
import majorProfile from './college/majorProfile'

import * as h2Api from '../h2Api'
import * as profileActions from '../actions/colleges'
import {
  ALL_COLLEGE_LISTING,
  COLLEGE_COMPARISON,
  COLLEGES_LOAD_COUNTS
} from '../actions/colleges'
import * as majorProfileActions from '../actions/majors'
import { ALL_MAJORS_LISTING, MAJOR_COMPARISON } from '../actions/majors'

const initialState = {
  selectedInstitutions: [],
  error: null
}
const occupationComparisonReducer = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.REMOVE_COLLEGE_FOR_COMPARISON:
      return {
        ...state,
        selectedInstitutions: state.selectedInstitutions.filter(i => i !== action.id)
      }

    case profileActions.COLLEGE_COMPARISON_SET_ERROR:
      return {
        ...state,
        error: action.error
      }
    case profileActions.CLEAR_COLLEGE_COMPARISON:
      return {
        ...state,
        selectedInstitutions: []
      }

    case profileActions.SELECT_COLLEGE_FOR_COMPARISON:
      if (state.selectedInstitutions.indexOf(action.id) >= 0) {
        return state
      }

      return {
        ...state,
        selectedInstitutions: [...state.selectedInstitutions, action.id]
      }

    default:
      return state
  }
}
const initialMajorState = {
  selectedMajors: [],
  error: null
}
const majorComparisonReducer = (state = initialMajorState, action) => {
  switch (action.type) {
    case majorProfileActions.REMOVE_MAJOR_FOR_COMPARISON:
      return {
        ...state,
        selectedMajors: state.selectedMajors.filter(i => i !== action.id)
      }

    case majorProfileActions.MAJOR_COMPARISON_SET_ERROR:
      return {
        ...state,
        error: action.error
      }
    case majorProfileActions.CLEAR_MAJOR_COMPARISON:
      return {
        ...state,
        selectedMajors: []
      }

    case majorProfileActions.SELECT_MAJOR_FOR_COMPARISON:
      if (state.selectedMajors.indexOf(action.id) >= 0) {
        return state
      }

      return {
        ...state,
        selectedMajors: [...state.selectedMajors, action.id]
      }

    default:
      return state
  }
}
const college = combineReducers({
  collegeListingRequest: h2Api.restReducer(ALL_COLLEGE_LISTING),
  majorListingRequest: h2Api.restReducer(ALL_MAJORS_LISTING),
  collegeComparison: h2Api.restReducer(COLLEGE_COMPARISON),
  majorComparison: h2Api.restReducer(MAJOR_COMPARISON),
  collegeCounts: h2Api.restReducer(COLLEGES_LOAD_COUNTS),
  comparison: occupationComparisonReducer,
  majorComparisonItems: majorComparisonReducer,
  profile,
  majorProfile
})

export default college
